const config = {
  topMenu: false,
  rtl: false,
  darkMode: false,
  mainTemplate: 'lightMode',
};

export default config;
